/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentOpsPaymentEventDto } from './PaymentOpsPaymentEventDto';
import {
    PaymentOpsPaymentEventDtoFromJSON,
    PaymentOpsPaymentEventDtoFromJSONTyped,
    PaymentOpsPaymentEventDtoToJSON,
    PaymentOpsPaymentEventDtoToJSONTyped,
} from './PaymentOpsPaymentEventDto';
import type { PaymentState } from './PaymentState';
import {
    PaymentStateFromJSON,
    PaymentStateFromJSONTyped,
    PaymentStateToJSON,
    PaymentStateToJSONTyped,
} from './PaymentState';

/**
 * 
 * @export
 * @interface NonCapturedPaymentDto
 */
export interface NonCapturedPaymentDto {
    /**
     * 
     * @type {boolean}
     * @memberof NonCapturedPaymentDto
     */
    canExcludeFromWashing: boolean;
    /**
     * 
     * @type {Date}
     * @memberof NonCapturedPaymentDto
     */
    created: Date;
    /**
     * 
     * @type {Array<PaymentOpsPaymentEventDto>}
     * @memberof NonCapturedPaymentDto
     */
    events: Array<PaymentOpsPaymentEventDto>;
    /**
     * 
     * @type {number}
     * @memberof NonCapturedPaymentDto
     */
    executingLocationId: number;
    /**
     * 
     * @type {NonCapturedPaymentDtoLatestEventCodeEnum}
     * @memberof NonCapturedPaymentDto
     */
    latestEventCode: NonCapturedPaymentDtoLatestEventCodeEnum;
    /**
     * 
     * @type {number}
     * @memberof NonCapturedPaymentDto
     */
    paymentId: number;
    /**
     * 
     * @type {NonCapturedPaymentDtoPaymentMethodEnum}
     * @memberof NonCapturedPaymentDto
     */
    paymentMethod: NonCapturedPaymentDtoPaymentMethodEnum;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof NonCapturedPaymentDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof NonCapturedPaymentDto
     */
    paymentReference: string;
    /**
     * 
     * @type {Date}
     * @memberof NonCapturedPaymentDto
     */
    updated: Date;
    /**
     * 
     * @type {PaymentState}
     * @memberof NonCapturedPaymentDto
     */
    latestState?: PaymentState | null;
}


/**
 * @export
 */
export const NonCapturedPaymentDtoLatestEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type NonCapturedPaymentDtoLatestEventCodeEnum = typeof NonCapturedPaymentDtoLatestEventCodeEnum[keyof typeof NonCapturedPaymentDtoLatestEventCodeEnum];

/**
 * @export
 */
export const NonCapturedPaymentDtoPaymentMethodEnum = {
    CARD: 'CARD',
    VIPPS: 'VIPPS',
    APPLE_PAY: 'APPLE_PAY',
    MOBILE_PAY: 'MOBILE_PAY',
    GOOGLE_PAY: 'GOOGLE_PAY',
    SWISH: 'SWISH',
    INTEGRATED_TERMINAL: 'INTEGRATED_TERMINAL',
    MOBILE_CARD_TERMINAL: 'MOBILE_CARD_TERMINAL',
    INVOICE: 'INVOICE',
    CASH: 'CASH',
    FREE: 'FREE',
    BILL_ON_ROOM: 'BILL_ON_ROOM'
} as const;
export type NonCapturedPaymentDtoPaymentMethodEnum = typeof NonCapturedPaymentDtoPaymentMethodEnum[keyof typeof NonCapturedPaymentDtoPaymentMethodEnum];


/**
 * Check if a given object implements the NonCapturedPaymentDto interface.
 */
export function instanceOfNonCapturedPaymentDto(value: object): value is NonCapturedPaymentDto {
    if (!('canExcludeFromWashing' in value) || value['canExcludeFromWashing'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    if (!('executingLocationId' in value) || value['executingLocationId'] === undefined) return false;
    if (!('latestEventCode' in value) || value['latestEventCode'] === undefined) return false;
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function NonCapturedPaymentDtoFromJSON(json: any): NonCapturedPaymentDto {
    return NonCapturedPaymentDtoFromJSONTyped(json, false);
}

export function NonCapturedPaymentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonCapturedPaymentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'canExcludeFromWashing': json['canExcludeFromWashing'],
        'created': (new Date(json['created'])),
        'events': ((json['events'] as Array<any>).map(PaymentOpsPaymentEventDtoFromJSON)),
        'executingLocationId': json['executingLocationId'],
        'latestEventCode': json['latestEventCode'],
        'paymentId': json['paymentId'],
        'paymentMethod': json['paymentMethod'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentReference': json['paymentReference'],
        'updated': (new Date(json['updated'])),
        'latestState': json['latestState'] === undefined ? undefined : json['latestState'] === null ? null : PaymentStateFromJSON(json['latestState']),
    };
}

export function NonCapturedPaymentDtoToJSON(json: any): NonCapturedPaymentDto {
    return NonCapturedPaymentDtoToJSONTyped(json, false);
}

export function NonCapturedPaymentDtoToJSONTyped(value?: NonCapturedPaymentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'canExcludeFromWashing': value['canExcludeFromWashing'],
        'created': value['created'].toISOString(),
        'events': ((value['events'] as Array<any>).map(PaymentOpsPaymentEventDtoToJSON)),
        'executingLocationId': value['executingLocationId'],
        'latestEventCode': value['latestEventCode'],
        'paymentId': value['paymentId'],
        'paymentMethod': value['paymentMethod'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentReference': value['paymentReference'],
        'updated': value['updated'].toISOString(),
        'latestState': PaymentStateToJSON(value['latestState']),
    };
}

